import Button from "atoms/buttons/button";
import { ButtonStyles } from "atoms/constants/button-styles";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-page-block-context-menu";

const PageBlockContextMenu = ({
    onDelete,
    onMoveUp,
    onMoveDown,
    disableMoveDown = false,
    disableMoveUp = false,
    inline = false,
    mobileOnly = false,
}) => {
    return (
        <ul
            className={`${CSS_CLASS_NAME} ${inline ? "-inline" : ""} ${mobileOnly ? "-mobileOnly" : ""}`}>
            <MenuOption
                disabled={disableMoveUp}
                onClick={onMoveUp}
                ariaText={"moveToTop"}
                icon={Icons.ChevronUp}
            />
            <MenuOption
                disabled={disableMoveDown}
                onClick={onMoveDown}
                ariaText={"moveToBottom"}
                icon={Icons.ChevronDown}
            />
            <MenuOption
                onClick={onDelete}
                ariaText={"delete"}
                icon={Icons.Trashcan}
                iconClassName={"-danger"}
            />
        </ul>
    );
};

const MenuOption = ({
    icon,
    ariaText,
    onClick,
    disabled = false,
    iconClassName = "",
}) => {
    return (
        <li className={`${CSS_CLASS_NAME}__listItem`}>
            <Button
                disabled={disabled}
                style={ButtonStyles.None}
                cssClassName={`${CSS_CLASS_NAME}__button`}
                onClick={onClick}>
                <span className="sr-only">{t(ariaText)}</span>
                <Icon
                    size={IconSizes.Small}
                    cssClassName={`${CSS_CLASS_NAME}__icon ${iconClassName}`}
                    type={icon}
                />
            </Button>
        </li>
    );
};

export default PageBlockContextMenu;
